import apiClient from '../api-client';

export default {
	saveContactsMapping(
		fileId,
		contentType,
		containerPath,
		elementName,
		fileColumns,
		mappings,
		userId,
		isInternalUser,
	) {
		return apiClient().post('/ContactsImport/Read', {
			fileId,
			contentType,
			containerPath,
			elementName,
			fileColumns,
			mappings,
			userId,
			isInternalUser,
		});
	},
	saveContactsMappingv2({
		fileId,
		contentType,
		containerPath,
		elementName,
		fileColumns,
		mappings,
		contactId,
		entityId,
		userId,
		isInternalUser,
		leadTypeId,
	}) {
		// 35 seconds = 35000 milliseconds
		return apiClient('v2', 35000).post('/ContactsImport/Read', {
			fileId,
			contentType,
			containerPath,
			elementName,
			fileColumns,
			mappings,
			contactId,
			entityId,
			userId,
			isInternalUser,
			leadTypeId,
		});
	},
};
